<template>
  <question-editor
    :faq-id="faq.id"
    :question="question"
    :categories="faq.categories"
    :subcategories="faq.subcategories"
    :errors="errors"
    mode="edit"
  />
</template>

<script>
import QuestionEditor from '@/components/faq/QuestionEditor';
import Layout from '@/components/shared/TheLayout';
import TabsLayout from '@/components/faq/TabsLayout';

export default {
  components: {
    QuestionEditor
  },

  layout: (h, page) => h(Layout, {
    props: {
      noWrappingContainer: true,
      pageTitle: page.data.props.faq.default_translation.name
    }
  }, [h(TabsLayout, {
    props: {
      activeTab: null,
      faq: page.data.props.faq
    }
  }, [page])]),

  props: {
    faq: {
      type: Object,
      required: true
    },
    question: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      required: false,
      default: () => ({})
    }
  }
}
</script>